import { SupabaseClient } from "@supabase/supabase-js";
import { getSupabaseClientSync } from "@/app/_module/services/supabaseClient";

// Re-export the main Supabase client getter to avoid "Multiple GoTrueClient instances" warning
// All dialer components should use this single shared instance from the global singleton
export function getSupabaseClient(): SupabaseClient | null {
  return getSupabaseClientSync();
}
